export const name = 'addLFDeviceController';

export default function addLFDeviceController(
  rnHttp,
  rnDevice,
  $state,
  $stateParams,
  $window
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let myParams = {};

  let vm = this;
  vm.loading = true;
  vm.submitting = false;

  // controller functions
  vm.cancel = cancel;
  vm.goSignIn = goSignIn;
  vm.goSignUp = goSignUp;
  vm.printerVerified = false;

  activate();

  ////////////////////////
  function activate() {
    myParams.data = $stateParams.data;
    vm.code = $stateParams.lfCode;
    if (!vm.code && _.get(myParams, 'data.lfCode')) {
      vm.code = myParams.data.lfCode;
    }

    if ($stateParams.bu) {
      myParams.bu = $stateParams.bu;
      vm.bu = $stateParams.bu;
    }

    _.set(myParams, 'data.lfCode', vm.code);

    let config = {
      headers: {
        'If-Modified-Since': undefined,
        'Cache-Control': undefined
      },
      params: {
        sc: vm.code
      },
    };

    return rnHttp.get('lf_cc', 'ValidatePrinterSC', config).then(resp => {
      if (resp.data.status === 'invalid') {
        vm.errorKey = 'register.register.InvalidCode';
        return;
      }

      vm.device = {
        type: resp.data.type,
        model: resp.data.pn,
        serialNumber: resp.data.sn,
        securityCode: vm.code,
        internal: {},
      };
      rnDevice.addDisplayInfo(vm.device);

      vm.printerVerified = true;
    })
      .catch(error => {
        vm.errorKey = 'register.register.InvalidCode';
      })
      .finally(() => {
        vm.loading = false;
      });

    // DEVELOPER TESTING
    // vm.device = {
    //   type: 'LatexPrinter',
    //   model: 'CZ056A',
    //   serialNumber: 'AL687470771',
    //   internal: {}
    // };
    // rnDevice.addDisplayInfo(vm.device);
    // vm.printerVerified = true;
    // vm.loading = false;
    // END DEVELOPER TESTING

  }

  function goSignIn() {
    if (!vm.printerVerified) {
      return;
    }

    _.set(myParams, 'chooseAccount', true);
    // _.set(myParams, 'signout', true);
    _.set(myParams, 'forward', true);
    if (vm.code) {
      _.set(myParams, 'lfCode', vm.code);
      _.set(myParams, 'data.target.url', `${$window.location.origin}/account/#/devices/add/lf/${vm.code}`);
      // _.set(myParams, 'data.target.messageKey', 'register.register.AddPrinterSignIn');
    }
    $state.go('signin', myParams);
  }

  function goSignUp() {
    if (!vm.printerVerified) {
      return;
    }

    if (vm.code) {
      _.set(myParams, 'lfCode', vm.code);
      _.set(myParams, 'data.device', vm.device);
    }
    $state.go('signup', myParams);
  }

  function cancel() {
    $state.go('lf-code', myParams);
  }
}



// WEBPACK FOOTER //
// ./components/lf-add/lf-add.controller.js